module.exports = __webpack_public_path__ + "img/0ffe444.png";